import { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { IconClose } from './icons';

export default function Modal({ title, icon, children, onClose, footer, submitOnEnter, onSubmit }) {
  useEffect(() => {
    function onKeyDown(e) {
      if (e.key === 'Escape') onClose?.();
      if (e.key !== 'Enter') return;
      if (!submitOnEnter || typeof onSubmit !== 'function') return;
      if (e.shiftKey || e.altKey) return;
      const t = e.target;
      if (t instanceof HTMLTextAreaElement) return;
      if (t instanceof HTMLElement && t.isContentEditable) return;
      if (t instanceof HTMLInputElement) {
        const type = String(t.type || 'text').toLowerCase();
        if (!['text', 'search', 'email', 'url', 'tel', 'password', 'number'].includes(type)) return;
        e.preventDefault();
        onSubmit();
      }
    }
    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [onClose, submitOnEnter, onSubmit]);

  useEffect(() => {
    const body = document.body;
    const prevOverflow = body.style.overflow;
    body.style.overflow = 'hidden';
    return () => {
      body.style.overflow = prevOverflow;
    };
  }, []);

  if (typeof document === 'undefined') return null;

  return createPortal(
    <div className="ModalOverlay" role="presentation" onMouseDown={onClose}>
      <div className="Modal" role="dialog" aria-modal="true" aria-label={title} onMouseDown={(e) => e.stopPropagation()}>
        <div className="ModalHeader">
          <div className="ModalTitle">
            {icon ? <span className="IconWrap">{icon}</span> : null}
            <div className="TileTitle">{title}</div>
          </div>
          <button type="button" className="Button Button--ghost Button--icon" onClick={onClose} aria-label="Fermer">
            <IconClose />
          </button>
        </div>
        <div className="ModalBody">{children}</div>
        {footer ? <div className="ModalFooter">{footer}</div> : null}
      </div>
    </div>,
    document.body
  );
}
